import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import styles from './Modal.module.scss';
import { useModalStore } from '../../store/ModalStore';

interface ModalProps {
  children: React.ReactNode;
  onClose?: () => void;
}

const Modal: React.FC<ModalProps> = ({ children }) => {
  const open = useModalStore((state) => state.open);
  const setOpen = useModalStore((state) => state.setOpen);
  const [isVisible, setIsVisible] = useState(false);

  //проблема с прокруткой
  // useEffect(() => {
  //   const preventScroll = (e: TouchEvent) => e.preventDefault();

  //   if (isVisible) {
  //     document.body.style.overflow = 'hidden';
  //     document.addEventListener('touchmove', preventScroll, { passive: false });
  //   }

  //   return () => {
  //     document.body.style.overflow = '';
  //     document.removeEventListener('touchmove', preventScroll);
  //   };
  // }, [isVisible]);

  useEffect(() => {
    if (open === true || open === 'boost' || open === 'dailyReward') {
      setIsVisible(true);
    }
  }, [open]);

  const handleClose = () => {
    setIsVisible(false);
    setOpen(false);
  };

  if (!isVisible) {
    return null;
  }

  const modalContent = (
    <div className={styles.modalWrapper}>
      <div className={styles.modal}>
        <div className={styles.modalContent}>
          <button className={styles.closeButton} onClick={handleClose}></button>
          {children}
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default Modal;
